<template>
  <PageListLayout
    icon="mdi-file-multiple"
    title="Báo giá"
    subTitle="Danh sách báo giá"
    useAdd
    titleAdd="Thêm Báo Giá"
    @add="createItem"
    @reset-filter="resetFilter"
  >
    <template slot="filter">
      <div>
        <v-text-field
          append-icon="mdi-magnify"
          v-model="formSearch.search"
          label="Tìm kiếm"
          clearable
          single-line
          outlined
          dense
          hide-details
        ></v-text-field>
      </div>
      <div class="mt-4">
        <v-autocomplete
          :items="customersList"
          label="Khách hàng"
          outlined
          dense
          hide-details
          v-model="formSearch.customer_id"
          item-text="name"
          item-value="id"
          clearable
        >
          <template v-slot:item="data">
            <template>
              <v-list-item-content>
                <v-list-item-title
                  class="style_auto_complate"
                  :title="data.item.name"
                  v-html="data.item.name"
                ></v-list-item-title>
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
      </div>
      <div class="mt-4">
        <v-autocomplete
          :items="statusList"
          label="Trạng thái"
          item-text="name"
          item-value="value"
          outlined
          dense
          hide-details
          v-model="formSearch.status"
          clearable
        ></v-autocomplete>
      </div>
      <div class="mt-4">
        <v-autocomplete
          :items="productPriceTypes"
          label="Loại báo giá"
          item-text="name"
          item-value="id"
          outlined
          dense
          hide-details
          v-model="formSearch.product_price_type"
          clearable
        ></v-autocomplete>
      </div>
      <div class="mt-4">
        <v-menu
          v-model="showMenuDate"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="formSearch.price_date"
              append-icon="mdi-calendar"
              readonly
              outlined
              dense
              v-bind="attrs"
              v-on="on"
              label="Ngày báo giá"
              hide-details
              clearable
            ></v-text-field>
          </template>
          <v-date-picker
            locale="vi"
            v-model="formSearch.price_date"
            range
          ></v-date-picker>
        </v-menu>
      </div>
    </template>
    <template slot="side-right">
      <div class="d-flex">
        <div class="mr-4">
          <ButtonDateRange
            left
            icon="mdi-calendar-export"
            label="Xuất báo giá tổng hợp"
            v-model="formExportTH.date_range"
            :loading="formExportTH.loading"
            @save="exportBaoGiaTongHop"
          />
        </div>
        <div class="mr-4">
          <ButtonDateRange
            left
            label="Xuất báo giá"
            v-model="formExport.date_range"
            :loading="formExport.loading"
            @save="exportBaoGia"
          />
        </div>
      </div>
    </template>
    <CustomTable
      :headers="headers"
      :items="tableData"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      hide-default-footer
      :loading="loading"
      loading-text="Đang tải dữ liệu ..."
      :pageCount="pageCount"
      @change-page="changePage"
      classPaging="pt-2"
    >
      <template v-slot:[`item.icon`]="{ item }">
        <v-icon>{{ item.icon }}</v-icon>
      </template>
      <template v-slot:[`item.price_date`]="{ item }">
        {{ dateFormat(item.price_date) }}
      </template>
      <template v-slot:[`item.request_type`]="{ item }">
        <span>{{ getSourceName(requestTypeList, item.request_type) }}</span>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <span :class="`badge ${item.status && styleStatus[item.status]}`"
          >{{ getSourceName(statusList, item.status) }}
        </span>
      </template>
      <template v-slot:[`item.order`]="{ item }">
        <span>{{
          item.parent ? item.parent.order + "-" + item.order : item.order
        }}</span>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-menu>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :loading="btnLoading == item.id"
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="textColor">mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <!-- <v-list-item @click="print(item)">
                <v-list-item-title>
                  <v-icon class="mr-2"> mdi-printer </v-icon>
                  In báo giá</v-list-item-title
                >
              </v-list-item> -->
            <v-list-item
              v-for="(item, index) in menuHanlder(item)"
              :key="`list-item-${index}`"
              v-on="item.event"
            >
              <v-list-item-title>
                <v-icon class="mr-2"> {{ item.icon }} </v-icon>
                {{ item.text }}</v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </CustomTable>
  </PageListLayout>
</template>
<script>
import {
  getProductPrices,
  editProductPrices,
  deleteProductPrices,
  printProductPrices,
  exportProductPrices,
  exportProductPricesTotal,
  sendMail,
} from "@/api/baogia";
import KHACHHANG from "@/api/khachhang";
import { debounce } from "lodash";
import { formatDate } from "@/utils/date";
import { getDanhMucCon } from "@/api/danhmuc.js";
import { saveAs } from "file-saver";
import ButtonDateRange from "@/components/Date/button-date-range";
import {
  STATUS_LIST,
  STYLE_STATUS,
  NEWLY_CREATED,
  CUSTOMER_REJECT,
  REJECT,
  CANCEL,
} from "@/constants/baogia.js";
export default {
  components: {
    ButtonDateRange,
  },
  data() {
    return {
      customersList: [],
      showMenuDate: false,
      formSeach: {},
      page: 1,
      pageCount: 1,
      itemsPerPage: 10,
      tableData: [],
      productTypesData: [],
      btnLoading: -1,
      menu: {},
      loading: false,
      search: "",
      headers: [
        {
          text: "Mã báo giá",
          align: "start",
          sortable: false,
          value: "price_code",
        },
        { text: "Ngày báo giá", value: "price_date" },
        { text: "Người tạo báo giá", value: "price_by" },
        { text: "Loại báo giá", value: "product_price_type.name" },
        { text: "Tên khách hàng", value: "customers.name" },
        { text: "Địa chỉ khách hàng", value: "address" },
        { text: "Trạng thái báo giá", value: "status" },
        // { text: "Ghi chú", value: "description" },
        {
          text: "Hành động",
          value: "action",
          sortable: false,
          align: "center",
          width: "150",
        },
      ],
      requestTypeList: [
        { value: 1, name: "Yêu cầu báo giá mới" },
        { value: 2, name: "Yêu cầu báo giá thay thế" },
      ],
      styleStatus: STYLE_STATUS,
      statusList: STATUS_LIST,
      formSearch: {
        price_date: [],
      },
      productPriceTypes: [],
      formExport: {
        loading: false,
        date_range: [],
      },
      formExportTH: {
        loading: false,
        date_range: [],
      },
    };
  },
  created() {
    this.fetchProductPriceType();
    this.getAllList();
    this.getCustomersList();
  },
  watch: {
    formSearch: {
      deep: true,
      handler: debounce(async function(val) {
        this.page = 1;
        this.getAllList();
      }, 300),
    },
  },
  methods: {
    menuHanlder(item) {
      let menu = [
        {
          text: "Cập nhật",
          icon: "mdi-pencil",
          event: {
            click: ($event) => this.goEdit(item),
          },
          show: true,
        },
        {
          text: "In Báo giá",
          icon: "mdi-printer",
          event: {
            click: ($event) => this.goEdit(item),
          },
          show: true,
        },
        {
          text: "Gửi mail báo giá khách hàng",
          icon: "mdi-email-arrow-right-outline",
          event: {
            click: ($event) => this.sendMailConfirmer(item),
          },
          show: true,
        },
        {
          text: "Không thành công",
          icon: "mdi-cancel",
          event: {
            click: ($event) => this.updateStatusItem(item, CANCEL),
          },
          show: item.status == NEWLY_CREATED,
        },
        {
          text: "Báo thành công",
          icon: "mdi-check",
          event: {
            click: ($event) => this.updateStatusItem(item, NEWLY_CREATED),
          },
          show: item.status == CANCEL,
        },
        {
          text: "Xoá báo giá",
          icon: "mdi-delete",
          event: {
            click: ($event) => this.deleteItem(item),
          },
          show: this.checkRemovable(item),
        },
      ];
      return menu.filter((x) => x.show);
    },
    async exportBaoGia(date) {
      try {
        this.formExport.loading = true;
        const res = await exportProductPrices({ date, ...this.formSearch });
        if (res.isError) {
          this.$store.dispatch("toastAlert/error", "Lỗi in xuất báo giá");
          return;
        }
        saveAs(new Blob([res]), `bao_gia_${date[0]}_den_${date[1]}.xls`);
      } catch (error) {
        this.$store.dispatch("toastAlert/error", "Lỗi in xuất báo giá");
      } finally {
        this.formExport.loading = false;
      }
    },
    async exportBaoGiaTongHop(date) {
      try {
        this.formExportTH.loading = true;
        const res = await exportProductPricesTotal({
          date,
          ...this.formSearch,
        });
        if (res.isError) {
          this.$store.dispatch("toastAlert/error", "Lỗi in xuất báo giá");
          return;
        }
        saveAs(new Blob([res]), `bao_gia_${date[0]}_den_${date[1]}.xls`);
      } catch (error) {
        this.$store.dispatch("toastAlert/error", "Lỗi in xuất báo giá");
      } finally {
        this.formExportTH.loading = false;
      }
    },
    async fetchProductPriceType() {
      const res = await getDanhMucCon({ code: "LOAIBAOGIA", isActive: true });
      this.productPriceTypes = res;
    },
    dateFormat(e) {
      return formatDate(e);
    },
    resetFilter() {
      this.formSearch = this.$options.data.call(this).formSearch;
    },
    async getCustomersList() {
      let res = await KHACHHANG.getAllCustomers();
      this.customersList = res.data;
    },
    async getAllList() {
      this.loading = true;
      let data = await getProductPrices({
        page: this.page,
        perPage: this.itemsPerPage,
        ...this.formSearch,
      });
      this.loading = false;
      this.tableData = data.data;
      this.pageCount = data.last_page;
    },
    changePage(val) {
      this.page = val;
      this.getAllList();
    },
    editItem(item) {
      this.$refs.form.showFormEdit(item);
    },
    async deleteItem(item) {
      this.$confirmBox.show({
        title: "Xóa sản phẩm",
        width: 500,
        body:
          "Bạn có chắc chắn muốn xóa báo giá " +
          "<strong>" +
          item.price_code +
          " ?" +
          "</strong>",
        action: () => deleteProductPrices({ id: item.id, status: item.status }),
        onDone: this.getAllList,
      });
    },
    getSourceName(list, nameStatus) {
      return list.find((item) => item.value === nameStatus)
        ? list.find((item) => item.value === nameStatus).name
        : null;
    },
    createItem() {
      this.$router.push({ path: "/kinhdoanh/thembaogia" });
    },
    goEdit(item) {
      this.$router.push({ path: `/kinhdoanh/thembaogia/${item.id}` });
    },
    async updateStatusItem(item, status) {
      try {
        this.btnLoading = item.id;
        await editProductPrices(item.id, { status });
        this.getAllList();
      } finally {
        this.btnLoading = -1;
      }
    },
    checkRemovable(item) {
      return [NEWLY_CREATED, CUSTOMER_REJECT, REJECT].includes(item.status);
    },
    async print(item) {
      try {
        this.btnLoading = item.id;
        const res = await printProductPrices(item.id);
        if (res.isError) {
          this.$store.dispatch("toastAlert/error", "Lỗi in báo giá");
          return;
        }
        saveAs(new Blob([res]), "Chi_tiet_bao_gia.docx");
      } catch (error) {
        this.$store.dispatch("toastAlert/error", "Lỗi in báo giá");
      } finally {
        this.btnLoading = -1;
      }
    },
    sendMailConfirmer(item) {
      this.$confirmBox.show({
        title: "Gửi mail báo giá khách hàng",
        width: 500,
        body:
          "Bạn có chắc chắn muốn gửi báo giá khách hàng " +
          "<strong>" +
          item.customers.name +
          " ?" +
          "</strong>",
        action: () => this.sendmail(item.id),
        disableMessage: true,
      });
    },
    async sendmail(id) {
      this.loading = true;
      try {
        const res = await sendMail(id);
      } catch (error) {
        this.$toast.error(error.response.data.message, {
          position: "top-center",
          timeout: 2000,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          message: error,
        });
      }
      this.loading = false;
    },
  },
};
</script>
<style scoped>
.bg-customize-color {
  background-color: #2c4a26 !important;
}
.style_auto_complate {
  max-width: 200px;
}
</style>
